(function () {
  'use strict';

  var root = document.getElementById('sticky-cart-summary');
  if (!root) return;

  var imagesEl = root.querySelector('[data-sticky-cart-images]');
  var totalEl = root.querySelector('[data-sticky-cart-total]');
  var countEl = root.querySelector('[data-sticky-cart-count]');
  var openBtn = root.querySelector('[data-sticky-cart-open]');
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    if (moneyFormat && moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', formatted);
    }
    return '₹' + formatted;
  }

  function buildImageHTML(items) {
    var visible = items.slice(0, 2);
    var overflow = items.length - visible.length;
    var html = '';
    visible.forEach(function (item) {
      if (item.image) {
        var src = item.image;
        if (src.indexOf('?') === -1) src += '?width=120';
        html += '<img class="sticky-cart-summary__image" src="' + src + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" width="38" height="38" loading="lazy">';
      } else {
        html += '<span class="sticky-cart-summary__image sticky-cart-summary__image--placeholder" aria-hidden="true"></span>';
      }
    });
    if (overflow > 0) {
      html += '<span class="sticky-cart-summary__image-overflow">+' + overflow + '</span>';
    }
    return html;
  }

  function render(cart) {
    if (!cart) return;
    var count = cart.item_count || 0;
    root.dataset.itemCount = count;
    if (count > 0) {
      root.classList.remove('sticky-cart-summary--hidden');
      root.setAttribute('aria-hidden', 'false');
    } else {
      root.classList.add('sticky-cart-summary--hidden');
      root.setAttribute('aria-hidden', 'true');
    }
    if (countEl) countEl.textContent = count;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0);
    if (imagesEl && Array.isArray(cart.items)) {
      imagesEl.innerHTML = buildImageHTML(cart.items);
    }
  }

  function fetchCartAndRender() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { /* silent */ });
  }

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && typeof cart.item_count !== 'undefined') {
        render(cart);
      } else {
        fetchCartAndRender();
      }
    });
  });

  if (openBtn) {
    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open !== 'undefined') {
        drawer.open = true;
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { openMiniCart: true }
      }));
    });
  }
})();
